import {
    min,
    max,
    required,
    requiredIf,
} from '~/services/validators';
import ContactForm from '~/components/waste-removal/form/ContactForm.vue';
import WasteRemovalDetailsForm from '~/components/waste-removal/form/WasteRemovalDetailsForm.vue';
import ServiceForm from '~/components/waste-removal/form/ServiceForm.vue';
import SizeForm from '~/components/waste-removal/form/SizeForm.vue';
import TimeForm from '~/components/waste-removal/form/TimeForm.vue';
import UserForm from '~/components/user/UserForm.vue';

export default {
    data() {
        return {
            showUserStep: false,
        };
    },
    computed: {
        steps() {
            const steps = [
                {
                    component: ServiceForm,
                    name: 'service',
                    title: this.$t('waste_removal.form.select_a_service'),
                },
                ...(this.$form.services.$model && this.$form.services.$model !== 1 ? [{
                    component: SizeForm,
                    name: 'size',
                    title: this.$form.services.$model === 4
                        ? this.$t('waste_removal.form.select_specialist_service')
                        : this.$t('waste_removal.form.select_size'),
                }] : []),
                {
                    component: WasteRemovalDetailsForm,
                    name: 'details',
                    title: this.$t('waste_removal.form.enter_more_details'),
                    props: {
                        existingImages: this.existingImages || [],
                    },
                },
                {
                    component: TimeForm,
                    name: 'time',
                    title: this.services === 2
                        ? this.$t('waste_removal.form.select_delivery_time')
                        : this.$t('waste_removal.form.select_collection_time'),
                },
                {
                    component: ContactForm,
                    name: 'address',
                    title: this.$t('waste_removal.form.enter_contact_details'),
                },
            ];
            if (this.showUserStep) {
                steps.push({
                    component: UserForm,
                    name: 'user',
                    title: this.$t('business.your_details'),
                    props: {
                        buttonText: this.$t('waste_removal.get_quotes'),
                        disableRedirect: true,
                        showTextNotifications: true,
                    },
                });
            }
            return steps;
        },
    },
    validations: {
        accessInformation: [],
        categories: [
            {
                validator: requiredIf,
                field: 'services',
                value: 4,
                message: 'waste_removal.select_category',
            },
        ],
        date: [
            {
                validator: requiredIf,
                field: 'enumDate',
                value: 'specific',
                message: 'waste_removal.select_date',
            },
        ],
        description: [
            required,
            { validator: min, length: 10 },
            { validator: max, length: 1000 },
        ],
        enumDate: [{ validator: required, message: 'waste_removal.select_time' }],
        images: [],
        landType: [
            {
                validator: requiredIf,
                field: 'services',
                value: 2,
                message: 'waste_removal.select_land_type',
            },
        ],
        services: [
            { validator: required, message: 'waste_removal.select_service' },
        ],
        size: [],
    },
};
